// Recovered compiled webpack factory 92901. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { EditorPageClient: () => w });
  var n = r(95155),
    a = r(67909),
    o = r(20063),
    i = r(12115),
    s = r(89038),
    l = r(47650);
  let u = "font-['GeistMono','Geist_Mono',ui-monospace,monospace]",
    c = "font-['Geist',sans-serif]",
    d = [
      { id: "personal", label: "Personal project" },
      { id: "client", label: "Client work (freelance)" },
      { id: "agency", label: "Agency or studio" },
      { id: "marketing", label: "Marketing or content" },
      { id: "fun", label: "Fun / experimenting" },
      { id: "other", label: "Other" },
    ];
  function f(e) {
    // Cloud use-case survey is not part of the local editor.
    return null;
  }
  let b = "ultramock_use_case_shown_v1";
  async function h() {
    try {
      let e = await fetch("/api/use-case", { method: "GET", cache: "no-store" });
      if (!e.ok) return null;
      return await e.json();
    } catch {
      return null;
    }
  }
  function p() {
    try {
      window.sessionStorage.setItem(b, "1");
    } catch {}
  }
  function m() {
    try {
      return "1" === window.sessionStorage.getItem(b);
    } catch {
      return !1;
    }
  }
  function x(e) {
    // Cloud use-case survey is not part of the local editor.
    return null;
  }
  let g = (0, a.default)(
    () =>
      (function e(t) {
        let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
        return t().catch((n) => {
          if (r <= 0) throw n;
          return new Promise((n) => setTimeout(() => n(e(t, r - 1)), 1e3));
        });
      })(() =>
        Promise.all([
          r.e(1493),
          r.e(8140),
          r.e(3564),
          r.e(1831),
          r.e(1748),
          r.e(6641),
          r.e(4664),
          r.e(8718),
          r.e(2619),
          r.e(388),
          r.e(1464),
          r.e(8664),
          r.e(5210),
          r.e(3527),
          r.e(2696),
          r.e(4241),
          r.e(8720),
          r.e(3432),
          r.e(2308),
          r.e(6516),
          r.e(5239),
          r.e(6348),
          r.e(8264),
          r.e(1797),
          r.e(6091),
          r.e(4189),
          r.e(1788),
          r.e(1987),
          r.e(6241),
          r.e(81),
          r.e(2188),
          r.e(8762),
          r.e(892),
          r.e(716),
          r.e(7251),
          r.e(9886),
        ]).then(r.bind(r, 99886)),
      ),
    { loadableGenerated: { webpack: () => [99886] }, ssr: !1, loading: () => (0, n.jsx)(s.L, {}) },
  );
  function y() {
    let e = (0, o.useSearchParams)(),
      t = (null == e ? void 0 : e.get("project")) ?? "none";
    return (0, n.jsx)(g, {}, t);
  }
  function w() {
    return (
      (0, i.useLayoutEffect)(() => {
        let e = document.body;
        return (
          e.setAttribute("translate", "no"),
          e.classList.add("notranslate"),
          () => {
            (e.removeAttribute("translate"), e.classList.remove("notranslate"));
          }
        );
      }, []),
      (0, n.jsxs)(i.Suspense, {
        fallback: (0, n.jsx)(s.L, {}),
        children: [(0, n.jsx)(y, {}), (0, n.jsx)(x, {})],
      })
    );
  }
}
